import {IExtensionPoints, IPlugin, IServiceConfig} from "@athena-portal/core";
import {
    BaseRequestServiceImpl,
    CustomerPortalServiceImpl,
    IBaseRequestService,
    ICustomerPortalService,
    IPluginHelperService,
    PluginHelperServiceImpl,
    Types
} from "@falcon/services";
import {DashboardPage} from "../pages/dashboard/subscription/DashboardPage";
import {AnnualMotorDashboardPage} from "../pages/dashboard/annual/motor/dashboardPage/AnnualMotorDashboardPage";
import {IDashboardPluginConfig} from "./IDashboardPluginConfig";
import {AnnualAccountDetailsPage} from "../pages/dashboard/annual/motor/AnnualAccountDetailsPage";
import {ChangeCardPage} from "../pages/dashboard/common/payments/changeCard/ChangeCardPage"
import {PaymentDetailsPage} from '../pages/dashboard/common/payments/paymentDetails/subscription/PaymentDetailsPage';
import {CoronaSupportPage} from "../pages/dashboard/CoronaSupportPage"
import {QuotesPage} from "../pages/dashboard/common/quotesPage/QuotesPage"
import {AnnualQuotesPage} from "../pages/dashboard/common/quotesPage/AnnualQuotesPage"
import {YourCarsPage} from "../pages/dashboard/subscription/motor/yourCarsPage/YourCarsPage";
import {DocumentsPage} from "../pages/dashboard/subscription/DocumentsPage";
import {YourCarCoversPage} from "../pages/dashboard/subscription/motor/yourCarCoversPage/YourCarCoversPage";
import {
    YourRentersCoversPage
} from "../pages/dashboard/subscription/renters/yourRentersCoverPage/YourRentersCoversPage";
import {PickClaimKindPage} from "../pages/dashboard/common/PickClaimKindPage";
import {ValuablesPage} from "../pages/dashboard/subscription/renters/valuablesPage/ValuablesPage";
import {MakeRentersClaimPage} from "../pages/dashboard/subscription/renters/rentersClaims/MakeRentersClaimPage";
import {WhenAndWhereClaimPage} from "../pages/dashboard/subscription/renters/rentersClaims/WhenAndWhereClaimPage";
import {ClaimSubmittedPage} from "../pages/dashboard/subscription/renters/rentersClaims/ClaimSubmittedPage";
import {CardConsentPage} from "../pages/dashboard/common/payments/changeCard/subscription/CardConsentPage";
import {WindscreenOrGlassPage} from "../pages/dashboard/subscription/motor/motorClaims/WindscreenOrGlassPage";
import {UrgentClaimPage} from "../pages/dashboard/subscription/motor/motorClaims/UrgentClaimPage";
import {WhenDidItHappenPage} from "../pages/dashboard/subscription/motor/motorClaims/WhenDidItHappenPage";
import {MotorClaimSubmittedPage} from "../pages/dashboard/subscription/motor/motorClaims/MotorClaimSubmittedPage";
import {CoverDetailsPage} from "../pages/dashboard/subscription/motor/motorClaims/CoverDetailsPage";
import {MissedPaymentPage} from "../pages/dashboard/common/payments/missedPayment/MissedPaymentPage";
import {ClaimsPage} from "../pages/dashboard/subscription/renters/rentersClaims/ClaimsPage";
import {SelectPolicyPage} from "../pages/dashboard/subscription/renters/rentersClaims/SelectPolicyPage";
import {PaymentProcessingPage} from "../pages/dashboard/common/payments/PaymentProcessingPage";
import {PickAnnualMotorClaimKindPage} from "../pages/dashboard/annual/motor/claims/PickAnnualMotorClaimKindPage";
import {WindscreenOrBreakdownClaimPage} from "../pages/dashboard/annual/motor/claims/WindscreenOrBreakdownClaimPage";
import {OtherClaimPage} from "../pages/dashboard/annual/motor/claims/OtherClaimPage";
import {ClaimCoverDetailsPage} from "../pages/dashboard/annual/motor/claims/ClaimCoverDetailsPage";
import {WhenDidAccidentHappenPage} from "../pages/dashboard/annual/motor/claims/WhenDidAccidentHappenPage";
import {AnnualMotorClaimSubmittedPage} from "../pages/dashboard/annual/motor/claims/AnnualMotorClaimSubmittedPage";
import {
    MonthlyPaymentsDetailsPage
} from "../pages/dashboard/common/payments/paymentDetails/annual/MonthlyPaymentsDetailsPage";
import {YourCarCoverPage} from "../pages/dashboard/annual/motor/yourCarCover/YourCarCoverPage";
import {AnnualYourCarsPage} from "../pages/dashboard/annual/motor/yourCarsPage/AnnualYourCarsPage";
import {AnnualDocumentsPage} from "../pages/dashboard/annual/motor/documents/AnnualDocumentsPage";
import {
    AnnualPaymentDetailsPage
} from "../pages/dashboard/common/payments/paymentDetails/annual/AnnualPaymentDetailsPage";
import {StartPaymentPage} from "../pages/dashboard/common/payments/StartPaymentPage";
import {ExistingCardPaymentPage} from "../pages/dashboard/common/payments/ExistingCardPaymentPage";
import {NewCardPaymentPage} from "../pages/dashboard/common/payments/NewCardPaymentPage";
import {OldMotorPoliciesPage} from "../pages/dashboard/annual/motor/oldPolicies/OldMotorPoliciesPage";
import {OldMotorPolicySummaryPage} from "../pages/dashboard/annual/motor/oldPolicies/OldMotorPolicySummaryPage";
import {OldHomePoliciesPage} from "../pages/dashboard/annual/home/oldPolicies/OldHomePoliciesPage";
import {OldHomePolicySummaryPage} from "../pages/dashboard/annual/home/oldPolicies/OldHomePolicySummaryPage";
import {MultiPoliciesDashboardPage} from "../pages/dashboard/common/MultiPoliciesDashboardPage";
import {AccountDetailsPage} from "../pages/dashboard/subscription/AccountDetailsPage";
import {MultiPolicyAccountDetailsPage} from "../pages/dashboard/common/MultiPolicyAccountDetailsPage";
import {GetNewQuotePage} from "../pages/dashboard/common/quotesPage/GetNewQuotePage";
import {AnnualHomeDashboardPage} from "../pages/dashboard/annual/home/AnnualHomeDashboardPage";
import {PickAnnualHomeClaimKindPage} from "../pages/dashboard/annual/home/claims/PickAnnualHomeClaimKindPage";
import {ClaimDetailsPage} from "../pages/dashboard/annual/home/claims/ClaimDetailsPage";
import {HomeClaimSubmittedPage} from "../pages/dashboard/annual/home/claims/HomeClaimSubmittedPage";
import {AnnualHomeAccountDetailsPage} from "../pages/dashboard/annual/home/AnnualHomeAccountDetailsPage";
import {HomePolicySummaryPage} from "../pages/dashboard/annual/home/policySummary/HomePolicySummaryPage";
import {DirectDebitChangePaymentDayPage} from "../pages/dashboard/common/payments/DirectDebitChangePaymentDayPage";
import {PayOffBalancePage} from "../pages/dashboard/common/payments/payOffBalance/PayOffBalancePage";
import {PayOffBalanceNewCardPage} from "../pages/dashboard/common/payments/payOffBalance/PayOffBalanceNewCardPage";
import {CardPaymentProcessingPage} from "../pages/dashboard/common/payments/CardPaymentProcessingPage";
import {
    PayOffBalanceProcessingPage
} from "../pages/dashboard/common/payments/payOffBalance/PayOffBalanceProcessingPage";
import {MarketingPreferencesPage} from "../pages/dashboard/common/MarketingPreferencesPage";
import {PayOverdueInstalmentPage} from "../pages/dashboard/common/payments/missedPayment/PayOverdueInstalmentPage";
import {OutstandingPaymentPage} from "../pages/dashboard/common/payments/missedPayment/OutstandingPaymentPage";
import {AnnualHomeDocumentsPage} from "../pages/dashboard/annual/home/documents/AnnualHomeDocumentsPage";
import {HomeInsuranceQuotesPage} from "../pages/dashboard/common/quotesPage/HomeInsuranceQuotesPage";
import {OldPoliciesDashboardPage} from "../pages/dashboard/common/OldPoliciesDashboardPage";
import {
    DirectDebitRenewalChangePaymentDayPage
} from "../pages/dashboard/common/payments/DirectDebitRenewalChangePaymentDayPage";
import {
    CancelPolicyOrAutomaticRenewalPage
} from "../pages/dashboard/common/CancelPolicyOrAutomaticRenewalPage";
import {AllianzAdvantagePage} from "../pages/dashboard/common/advantages/AllianzAdvantagePage";
import {AllianzPromotionPage} from "../pages/AllianzPromotionPage";
import {CustomerViewOrGetQuotesPage} from "../pages/dashboard/common/quotesPage/CustomerViewOrGetQuotesPage";
import {AllianzOnlinePage} from "../pages/AllianzOnlinePage";
import {AllOtherMotorClaimsPage} from "../pages/dashboard/annual/motor/claims/AllOtherMotorClaimsPage"
import {HelpPage} from "../pages/dashboard/common/HelpPage"
import {
    DirectDebitChangePaymentPage
} from "../pages/dashboard/common/payments/changeDirectDebit/DirectDebitChangePaymentPage";
import {
    DirectDebitChangeRefundPage
} from "../pages/dashboard/common/payments/changeDirectDebit/DirectDebitChangeRefundPage";
import {LoggedInComplaintsPage} from "../pages/complaint/LoggedInComplaintsPage";
import CommunicationArchivePage from "../pages/dashboard/common/documents/CommunicationArchivePage";
import {MultiTabWarningPage} from "../pages/MultiTabWarningPage";

const plugin: IPlugin<IDashboardPluginConfig> = {
    getName(): string {
        return "dashboard";
    },

    register(extensions: IExtensionPoints, configuration: IDashboardPluginConfig): void {
        // Routes
        extensions.routes.add(
            {
                path: "/dashboard",
                component: MultiPoliciesDashboardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/allianzPromotion",
                component: AllianzPromotionPage,
            }
        );

        extensions.routes.add(
            {
                path: "/multiTab",
                component: MultiTabWarningPage,
            }
        );

        extensions.routes.add(
            {
                path: "/allianzOnline",
                component: AllianzOnlinePage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotor/:policyNumber",
                component: AnnualMotorDashboardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualHome/:policyNumber",
                component: AnnualHomeDashboardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/monthlySubscription",
                component: DashboardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/rentersClaims",
                component: ClaimsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/rentersClaims/new",
                component: MakeRentersClaimPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/rentersClaims/whenAndWhere",
                component: WhenAndWhereClaimPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/rentersClaims/whenAndWhere/claimSuccess",
                component: ClaimSubmittedPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/windscreen",
                component: WindscreenOrGlassPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/windscreen/urgent",
                component: UrgentClaimPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/otherClaims",
                component: OtherClaimPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/otherClaims/coverDetails",
                component: ClaimCoverDetailsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/otherClaims/coverDetails/occur",
                component: WhenDidAccidentHappenPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/otherClaims/coverDetails/occur/success",
                component: AnnualMotorClaimSubmittedPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/windscreen/urgent/coverDetails",
                component: CoverDetailsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/windscreen/urgent/coverDetails/occur",
                component: WhenDidItHappenPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/windscreen/urgent/coverDetails/occur/success",
                component: MotorClaimSubmittedPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/pickClaimKind",
                component: PickClaimKindPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/selectCoverage",
                component: SelectPolicyPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/pickAnnualMotorClaimKind/:policyNumber",
                component: PickAnnualMotorClaimKindPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/wolfWindscreenOrBreakdownPage/:policyNumber",
                component: WindscreenOrBreakdownClaimPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/yourCars",
                component: YourCarsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotor/yourCars/:policyNumber",
                component: AnnualYourCarsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/yourCarCovers",
                component: YourCarCoversPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/advantages",
                component: AllianzAdvantagePage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotor/policySummary/:policyNumber",
                component: YourCarCoverPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotorOldPolicies",
                component: OldMotorPoliciesPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotorOldPolicies/:policyNumber",
                component: OldMotorPolicySummaryPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualHomeOldPolicies",
                component: OldHomePoliciesPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualHomeOldPolicies/:policyNumber",
                component: OldHomePolicySummaryPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/yourRentersCovers",
                component: YourRentersCoversPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/:product/cancel/:policyNumber",
                component: CancelPolicyOrAutomaticRenewalPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/valuables",
                component: ValuablesPage,
            }
        );


        extensions.routes.add(
            {
                path: "/dashboard/account",
                component: AccountDetailsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/multiPolicy/account",
                component: MultiPolicyAccountDetailsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/marketing-preferences",
                component: MarketingPreferencesPage,
            }
        )
        extensions.routes.add(
            {
                path: "/dashboard/annualMotorAccount/:policyNumber",
                component: AnnualAccountDetailsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualHome/account/:policyNumber",
                component: AnnualHomeAccountDetailsPage,
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/account/cardConsent",
                component: CardConsentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeCard/:policyNumber/:paymentReference",
                component: ChangeCardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeCard/:policyNumber",
                component: ChangeCardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeCard2/:paymentReference",
                component: ChangeCardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeCard",
                component: ChangeCardPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changePaymentDay/:policyNumber",
                component: DirectDebitChangePaymentDayPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/changeRenewalPaymentDay/:policyNumber",
                component: DirectDebitRenewalChangePaymentDayPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/missedPayment",
                component: MissedPaymentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/missedPolicyPayment/:policyNumber",
                component: MissedPaymentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/missedPolicyPayment/:policyNumber/:invoiceId",
                component: MissedPaymentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/payOverdueInstalment/:policyNumber",
                component: PayOverdueInstalmentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/payOverdueInstalment/:policyNumber/:invoiceId",
                component: PayOverdueInstalmentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/outstandingPayment/:policyNumber",
                component: OutstandingPaymentPage,
            }
        );


        extensions.routes.add(
            {
                path: "/dashboard/account/missedPayment/:paymentReference",
                component: MissedPaymentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/paymentProcessing",
                component: PaymentProcessingPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/paymentProcessing/:paymentReference",
                component: PaymentProcessingPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/paymentProcessing/:paymentReference/:policyNumber",
                component: PaymentProcessingPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/paymentProcessing/:paymentReference/:policyNumber/:invoiceId",
                component: PaymentProcessingPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/startPayment/:policyNumber",
                component: StartPaymentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/existingCardPayment/:policyNumber",
                component: ExistingCardPaymentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/newCardPayment/:policyNumber",
                component: NewCardPaymentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/:policyNumber/cardPaymentProcessing",
                component: CardPaymentProcessingPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/account/:policyNumber/cardPaymentProcessing/:paymentReference",
                component: CardPaymentProcessingPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/paymentHistory",
                component: PaymentDetailsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualPaymentHistory/:policyNumber",
                component: AnnualPaymentDetailsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/monthlyPaymentHistory/:policyNumber",
                component: MonthlyPaymentsDetailsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/:policyNumber/paymentDetails/editDirectDebit/",
                component: DirectDebitChangePaymentPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/:policyNumber/refundDetails/editDirectDebit/",
                component: DirectDebitChangeRefundPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/corona",
                component: CoronaSupportPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/quotes",
                component: QuotesPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualQuotes",
                component: AnnualQuotesPage,
            }
        );

        extensions.routes.add({
            path: "/dashboard/viewOrGetQuotes",
            component: CustomerViewOrGetQuotesPage,
        });

        extensions.routes.add({
            path: "/dashboard/HomeInsuranceQuotes",
            component: HomeInsuranceQuotesPage,
        });

        extensions.routes.add(
            {
                path: "/dashboard/documents",
                component: DocumentsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualMotorDocuments/:policyNumber",
                component: AnnualDocumentsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/annualHomeDocuments/:policyNumber",
                component: AnnualHomeDocumentsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/CommunicationArchivePage",
                component: CommunicationArchivePage,
            }
        );

        extensions.routes.add({
            path: "/dashboard/getNewQuote",
            component: GetNewQuotePage,
        });

        extensions.routes.add(
            {
                path: "/dashboard/annualHome/:policyNumber/claims/new",
                component: PickAnnualHomeClaimKindPage,
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/annualHome/:policyNumber/claims/details",
                component: ClaimDetailsPage,
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/annualHome/:policyNumber/claims/submitted",
                component: HomeClaimSubmittedPage,
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/annualHome/policySummary/:policyNumber",
                component: HomePolicySummaryPage,
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/:policyNumber/payOffBalance",
                component: PayOffBalancePage,
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/:policyNumber/payOffBalance/newCard",
                component: PayOffBalanceNewCardPage,
            }
        )

        extensions.routes.add(
            {
                path: "/dashboard/:policyNumber/payOffBalance/processing/:paymentReference",
                component: PayOffBalanceProcessingPage,
            }
        );

        extensions.routes.add({
            path: "/dashboard/annualOldPolicies",
            component: OldPoliciesDashboardPage,
        });

        extensions.routes.add(
            {
                path: "/dashboard/allOtherMotorClaimsPage/:policyNumber",
                component: AllOtherMotorClaimsPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/help",
                component: HelpPage,
            }
        );

        extensions.routes.add(
            {
                path: "/dashboard/complaints",
                component: LoggedInComplaintsPage,
            }
        );

        // Services
        extensions.services.bind<ICustomerPortalService>(Types.CustomerPortalService).to(CustomerPortalServiceImpl);
        extensions.services.bind<IServiceConfig>(Types.CustomerPortalServiceConfig).toConstantValue(configuration.customerPortalApiService);

        extensions.services.bind<IPluginHelperService>(Types.PluginHelperService).to(PluginHelperServiceImpl);
        extensions.services.bind<IBaseRequestService>(Types.BaseRequestService).to(BaseRequestServiceImpl);
    },
};

export default plugin;
